import { IconCookie, IconGauge, IconUser } from '@sloyd/icons';
import { Badge, Card, Container, Group, SimpleGrid, Text, Title, useMantineTheme } from '@sloyd/ui';
import classes from './Features.module.css';
import { Wrapper } from './Features.style';

const mockdata = [
  {
    title: 'Fast Iterations',
    description:
      'Generate dozens of high-quality models in minutes, reducing production time for both individual assets and large packs.',
    icon: IconUser,
  },
  {
    title: 'Complete Customization',
    description:
      'Take control over every detail, from triangle count to advanced texture settings, ensuring your models fit your exact specifications.',
    icon: IconCookie,
  },
  {
    title: 'Consistent Results',
    description: 'Maintain uniform style, triangle count, and texture UV maps across every model.',
    icon: IconGauge,
  },
];

export type FeaturesProps = {};

export function Features(_props: FeaturesProps) {
  const theme = useMantineTheme();
  const features = mockdata.map((feature) => (
    <Card key={feature.title} shadow='md' radius='md' className={classes.card} padding='xl'>
      <feature.icon size={50} stroke={2} color={theme.colors.blue[6]} />
      <Text fz='lg' fw={500} className={classes.cardTitle} size='md'>
        {feature.title}
      </Text>
      <Text fz='sm' c='dimmed' size='sm'>
        {feature.description}
      </Text>
    </Card>
  ));

  return (
    <Wrapper className='Features-wrapper' data-testid='Features-wrapper'>
      <Container size='lg' py='xl'>
        <Group justify='center'>
          <Badge variant='filled' size='lg' color='blue'>
            AI-Powered 3D Creation
          </Badge>
        </Group>

        <Title order={2} className={classes.title} ta='center' size='sm'>
          Unlock Limitless Creativity with Sloyd
        </Title>

        <Text c='dimmed' className={classes.description} ta='center' size='md'>
          From game developers to 3D printing enthusiasts, Sloyd’s advanced tools let you create,
          iterate, and customize like never before. Transform your ideas into reality with
          unparalleled speed and precision.
        </Text>

        <SimpleGrid cols={{ base: 1, md: 3 }} spacing='xl' size={50}>
          {features}
        </SimpleGrid>
      </Container>
    </Wrapper>
  );
}

export default Features;
